import { useFlags } from 'launchdarkly-react-client-sdk';

import { useNoteFormContext } from '../../context/noteFormContext';
import { AudioPlayer as AudioPlayerComponent } from '../../audioPlayer';

export const AudioPlayer = () => {
  const { note } = useNoteFormContext();
  const { aiScribe: enableAiScribe } = useFlags();

  // Only show when AI scribe failed, has no transcript, but has audio
  const shouldShow =
    enableAiScribe &&
    note?.aiScribe?.status === 'FAILED' &&
    !note?.aiScribe?.transcript &&
    note?.aiScribe?.audioUrl;

  if (!shouldShow || !note) return null;

  return <AudioPlayerComponent note={note} />;
};
